import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { RedDataCell, RedHeadCell, RedRow, RedTable } from './_shared/BradescoTable'
import { TABLE_STRIPE_TINT } from '../_helpers/brand'

// Conteúdo real (não placeholder) da tabela "Controle de Revisões": fixo no modelo
// aprovado por Julia Buzzo ("Modelo PGR 2026 - Banco Bradesco_Varejo"), replicado por
// completo em toda dependência (única revisão existente até o momento, versão "00" —
// não há indicação de que isso varie por atividade/dependência).
const REVISOES = [
  {
    versao: '00',
    data: '04/12/2025',
    alteracao: 'Elaboração do documento',
    elaboradoPor: ['Joyce Dhaiane de A. Paiva', 'Nathalia Correia Naolisk', 'Patrícia Harumi Omi Gramani', 'Paula Alves Gomes Luengo']
  }
]

/**
 * Página "Controle de Revisões" — confirmada como faltante no PDF-modelo real ("Modelo
 * PGR 2026 - Banco Bradesco_Varejo", página 5, entre o Sumário e a Seção 1). Uma versão
 * anterior deste PR já tinha identificado essa página no modelo, mas a deixou de fora
 * deliberadamente por estar fora do escopo daquela tarefa (ver histórico em
 * `00b.SumarioSection.js`) — esta tarefa pede explicitamente para adicioná-la.
 *
 * Layout confirmado por inspeção pixel-a-pixel: título "CONTROLE DE REVISÕES" em uma
 * barra vermelha sólida ocupando as 4 colunas (texto branco), sub-cabeçalho de colunas
 * "Versão | Data | Alteração | Elaborado por" com fundo pêssego claro (`TABLE_STRIPE_TINT`,
 * a mesma tinta usada no zebra das outras tabelas do documento) e texto preto, e uma linha
 * de dados por revisão.
 *
 * SEM `pageBreakAfter` (bug reportado por Julia Buzzo com screenshot: página com a tabela
 * no topo e o resto em branco antes da próxima página começar). No modelo real esta
 * tabela também é seguida só de espaço em branco porque é uma página estática — mas o
 * PDF gerado aqui não é estático: a Seção 1 que vem depois pode ter qualquer tamanho, e
 * forçar uma quebra fixa aqui deixa esse espaço em branco sempre, mesmo quando não é
 * necessário. Correção é só de layout (ver `PdfDocument.js` para o contexto mais amplo,
 * que é o mesmo em todas as seções numeradas do corpo do documento) — conteúdo/cálculo
 * não foram tocados.
 *
 * ESPAÇAMENTO EM RELAÇÃO AO SUMÁRIO (pedido explícito da Julia — ver "Ajustes
 * bradesco.pdf"): esta seção precisa continuar na MESMA página que o Sumário
 * (`00b.SumarioSection.js`, ver acima — sem `pageBreakAfter` em nenhuma das duas, então
 * o navegador só quebra a página onde o conteúdo de fato não couber mais, exatamente como
 * antes), só que com um respiro visual mais deliberado entre as duas — não "coladas" uma
 * na outra. `Separator weight={15}` aqui + `weight={15}` que já fecha o Sumário somam
 * 30px de espaço entre o fim do Sumário e o título "CONTROLE DE REVISÕES" — mantido
 * (não é o assunto deste ajuste), mas documentado aqui para deixar claro que é
 * intencional, não um espaçamento "de sobra" que poderia ser removido.
 */
const ControleRevisoesSection = () => (
  <View>
    <Separator weight={15} />

    <RedTable width="100%">
      <RedRow>
        <RedHeadCell colSpan={4}>CONTROLE DE REVISÕES</RedHeadCell>
      </RedRow>
      <RedRow>
        <RedHeadCell width="10%" bgColor={TABLE_STRIPE_TINT}>
          Versão
        </RedHeadCell>
        <RedHeadCell width="15%" bgColor={TABLE_STRIPE_TINT}>
          Data
        </RedHeadCell>
        <RedHeadCell bgColor={TABLE_STRIPE_TINT}>Alteração</RedHeadCell>
        <RedHeadCell width="25%" bgColor={TABLE_STRIPE_TINT}>
          Elaborado por
        </RedHeadCell>
      </RedRow>

      {REVISOES.map(revisao => (
        <RedRow key={revisao.versao}>
          <RedDataCell align="center">{revisao.versao}</RedDataCell>
          <RedDataCell align="center">{revisao.data}</RedDataCell>
          <RedDataCell align="center">{revisao.alteracao}</RedDataCell>
          <RedDataCell align="center">
            {revisao.elaboradoPor.map(nome => (
              <React.Fragment key={nome}>
                {nome}
                <br />
              </React.Fragment>
            ))}
          </RedDataCell>
        </RedRow>
      ))}
    </RedTable>
  </View>
)

export default ControleRevisoesSection
